import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HumanPipe } from '../../shared/pipes/human.pipe';

@Component({
  selector: 'app-chat-document-chip',
  standalone: true,
  templateUrl: './chat-document-chip.component.html',
  styleUrl: './chat-document-chip.component.scss',
  imports: [
    CommonModule,
    HumanPipe
  ]
})
export class ChatDocumentChipComponent {
  @Input() chat: any;
}
